import React, {Component} from 'react'
import {connect} from 'react-redux'
import '../sass/property-stack.css'
class PropertyStack extends Component {

    render() {
        return (
            <div className="property-stack">{this.props.children}</div>
        )
    }
}

function mapStateToProps(state, props) {
    return {
    }
}


export default connect(mapStateToProps)(PropertyStack)


// WEBPACK FOOTER //
// ./src/components/PropertyStack.js